import axios, { AxiosError } from 'axios';

export const updateToken = (token: string) => {
  localStorage.setItem('access_token', token);
};

const createAxiosInstance = (baseURL: string) => {
  const instance = axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('access_token')}`,
    },
  });

  instance.interceptors.request.use(
    (config) => {
      if(!config.headers) return config

      if (localStorage.getItem('access_token')) {
        config.headers['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`;
      }

      if (localStorage.getItem('hub_uuid')) {
        config.headers['hub-uuid'] = localStorage.getItem('hub_uuid') as string;
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error: AxiosError) => {
      //@ts-ignore
      if ((error.response && error.response.status === 401) || (error.response.data.error === "An error while decoding token.")) {
          window.location.href = '/entrar';
          window.localStorage.clear()
          return Promise.reject(error);
      }

      if (error.response && error.response.data) {
        //@ts-ignore
        const customError = error.response.data.error || error.response.data.message || 'Erro desconhecido';
        return Promise.reject(customError);
      }

      return Promise.reject(error);
    }
  );

  return instance;
};

export default createAxiosInstance;
